import { render, staticRenderFns } from "./sup-account-binding.vue?vue&type=template&id=38ea7479"
import script from "./sup-account-binding.vue?vue&type=script&lang=js"
export * from "./sup-account-binding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports